
// Fancy global scope, every module can access variable _

// Put this at the top of every js file:
// let _ = require('./_.js');

if (!window._LP) {
    window._LP = {}
}

module.exports = window._LP;